import React from "react";

import { FaShoppingCart } from "react-icons/fa";
import { MdOutlineLabelImportant } from "react-icons/md";
import Image from "../../designLayouts/Image";
import Badge from "./Badge";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToCart } from "../../../redux/orebiSlice";

const Product = (props) => {
  const dispatch = useDispatch();
  const _id = props.productName;
  const idString = (_id) => {
    return String(_id).toLowerCase().split(" ").join("");
  };
  const rootId = idString(_id);

  const navigate = useNavigate();
  const productItem = props;
  const handleProductDetails = () => {
    navigate(`/product/${rootId}`, {
      state: {
        item: productItem,
      },
    });
  };
  return (
    <div className="w-full relative group">
      <div className="max-w-80 max-h-80 relative overflow-y-hidden ">
        <div>
          <Image className="w-full h-full" imgSrc={props.img} />
        </div>
        <div className="absolute top-6 left-8">
          {props.badge && <Badge text="New" />}
        </div>

        {props.offer && (
  <div className="absolute top-6 right-8 bg-red-500 text-white text-xl px-3 py-1 ">
    10% off
  </div>
)}

{props.offer1 && (
  <div className="absolute top-6 right-8 bg-red-500 text-white text-xl px-3 py-1 ">
    15% off
  </div>
)}
{props.offer2 && (
  <div className="absolute top-6 right-8 bg-red-500 text-white text-xl px-3 py-1 ">
    20% off
  </div>
)}
{props.offer3 && (
  <div className="absolute top-6 right-8 bg-red-500 text-white text-xl px-3 py-1 ">
    25% off
  </div>
)}
{props.offer4 && (
  <div className="absolute top-6 right-8 bg-red-500 text-white text-xl px-3 py-1 ">
    5% off
  </div>
)}
{props.offer5 && (
  <div className="absolute top-6 right-8 bg-red-500 text-white text-xl px-3 py-1 ">
    30% off
  </div>
)}
{props.offer6 && (
  <div className="absolute top-6 right-8 bg-red-500 text-white text-xl px-3 py-1 ">
    35% off
  </div>
)}
{props.offer7 && (
  <div className="absolute top-6 right-8 bg-red-500 text-white text-xl px-3 py-1 ">
    40% off
  </div>
)}


        <div className="w-full h-20 absolute bg-white -bottom-[130px] group-hover:bottom-0 duration-700">
          <ul className="w-full h-full flex flex-col items-end justify-center gap-2 font-titleFont px-2 border-l border-r">
           
            <li
              onClick={() =>
                dispatch(
                  addToCart({
                    _id: props._id,
                    name: props.productName,
                    quantity: 1,
                    image: props.img,
                    badge: props.badge,
                    price: props.price,
                    colors: props.color,
                  })
                )
              }
              className="text-[#767676] hover:text-primeColor text-sm font-normal border-b-[1px] border-b-gray-200 hover:border-b-primeColor flex items-center justify-end gap-2 hover:cursor-pointer pb-1 duration-300 w-full"
            >
              Add to Cart
              <span>
                <FaShoppingCart />
              </span>
            </li>
            <li
              onClick={handleProductDetails}
              className="text-[#767676] hover:text-primeColor text-sm font-normal border-b-[1px] border-b-gray-200 hover:border-b-primeColor flex items-center justify-end gap-2 hover:cursor-pointer pb-1 duration-300 w-full"
            >
              View Details
              <span className="text-lg">
                <MdOutlineLabelImportant />
              </span>
            </li>
           
          </ul>
        </div>
      </div>
      <div className="max-w-80 py-6 flex flex-col gap-1 border-[1px] border-t-0 px-4">
        <div className="flex items-center justify-between font-titleFont">
          <h2 className="text-lg text-primeColor font-bold">
            {props.color}
          </h2>
          <p className="text-[#767676] text-[14px]">Rs.{props.price}</p>
        </div>
        <div>
          <p className="text-[#767676] text-[14px]">{props.productName}</p>
        </div>
      </div>
    </div>
  );
};

export default Product;
